<template>
    <div class="full-page auth">
        <div class="wrapper wrapper-full-page">
            <notifications/>
            <div class="page-header header-filter"
                 :class="setPageClass">
                <div class="flex w-full h-screen">
                    <div class="hidden 2xl:w-1/3 2xl:block bg-white">
                        <div class="flex flex-col justify-between h-full">
                            <div class="container-logo h-3/4">
                                <img :src="logo" alt="logo" class="max-w-xs 2xl:max-w-md" />
                            </div>
                            <footer class="footer h-1/4">
                                <div class="container">
                                    <nav class="mx-auto">
                                        <div class="flex items-center justify-evenly">
                                            <p>GMD Sanitation</p>
                                            <p>85 rue Conrad Kilian 07500 Guilherand-Granges</p>
                                        </div>
                                        <div class="flex items-center justify-evenly">
                                            <md-button class="md-primary" href="tel:+33475404750" target="_blank">
                                                Tél. 04 75 40 47 50
                                            </md-button>
                                            <md-button class="md-primary" href="mailto:experts@gmd-sanitation.com">
                                                experts@gmd-sanitation.com
                                            </md-button>
                                        </div>
                                    </nav>
                                </div>
                            </footer>
                        </div>
                    </div>
                    <div class="w-full 2xl:w-2/3 filter-black bg-danger">
                        <div class="flex 2xl:items-center 2xl:flex-row h-full flex-col justify-between">
                            <div class="2xl:hidden 2xl:bg-transparent h-1/4 flex flex-col justify-center px-4 bg-white z-50">
                                <div class="container-logo">
                                    <img :src="logo" alt="logo" class="max-w-2xs 2xl:max-w-lg" />
                                </div>
                            </div>
                            <div class="w-full h-3/4 2xl:h-auto">
                                <div class="w-full h-full relative z-10 flex items-center">
                                    <zoom-center-transition :duration="pageTransitionDuration"
                                                            mode="out-in">
                                        <router-view></router-view>
                                    </zoom-center-transition>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import logo from '@/assets/images/logo.png'
export default {
    name: "ProgressiveWebAppAuth",
    data() {
        return {
            responsive: false,
            showMenu: false,
            menuTransitionDuration: 250,
            pageTransitionDuration: 300,
            year: new Date().getFullYear(),
            logo: logo
        };
    },
    computed: {
        setPageClass() {
            return `${this.$route.name}-page`.toLowerCase();
        },
    }
}
</script>

<style scoped lang="scss">
footer {
    p {
        color: #3c4858;
        padding: 15px;
        font-weight: 500;
        border-radius: 3px;
        text-decoration: none;
        position: relative;
        display: block;
        font-size: 13px !important;
        text-transform: uppercase !important;
    }
}
</style>
